import { Link, usePush } from '@dreryk/react-components';

import { healthcareProviderPaths } from '~libs.desktop.shared.paths';
import { useGetCurrentHealthcareProviderType } from '~libs.shared.account';

import { translationKeys } from '../translations';

const t = translationKeys.faults;

export const AiAssistantBuyTokensLink = (): JSX.Element => {
   const push = usePush();
   const healthcareProviderType = useGetCurrentHealthcareProviderType();

   const handleClick = (): void => {
      push(healthcareProviderPaths.getAiAssistantSettingsPath(healthcareProviderType));
   };

   return <Link testId={'buyTokens'} label={t.buyTokens} block={false} onClick={handleClick} />;
};
